import _ from 'lodash';
import React, { Component, ReactNode } from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

type Primitive = string | number;

export interface OptionType<T extends Primitive> {
  label: ReactNode;
  value: T;
}

type OptionTypeCallback<T extends Primitive> = (option: OptionType<T> | null) => void;

interface SelectTypeProps<T extends Primitive> {
  type: Primitive;
  value: OptionType<T> | T | null | undefined;
  onChange: OptionTypeCallback<T>;
  disabled?: boolean;
  className?: string;
  filterOption?: (option: OptionType<T> | null, inputValue: string) => boolean;
  menuPlacement?: string;
}

interface SelectTypeState<T extends Primitive> {
  types: OptionType<T>[];
  isLoading: boolean;
}

export default class SelectType<T extends Primitive = Primitive> extends Component<
  SelectTypeProps<T>,
  SelectTypeState<T>
> {
  static defaultProps = {
    placeholder: 'Select a type',
  };

  state = { types: [], isLoading: true };

  async componentDidMount() {
    const { type } = this.props;
    try {
      interface CorpTypesResponse {
        result: T[];
      }
      // TODO: refactor to use imports from shared/defaults
      const { result } = await apiFetch<CorpTypesResponse>(null, `corp-api/types/${type}`);
      const types = result.map(value => ({ value, label: value }));
      this.setState({ types });
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    } finally {
      this.setState({ isLoading: false });
    }
  }

  render() {
    const selectProps = _.omit(this.props, 'type');

    return <Select isLoading={this.state.isLoading} {...selectProps} options={this.state.types} />;
  }
}
